import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../components/Home'
import Wishlist from '../components/WishProduct/Wishlist'
import Orders from '../components/Orders/MyOrders'
import OrderDetails from '../components/Orders/OrderDetails'
import Payments from '../components/Payments/PaymentList'
import Profile from '../components/Profile/ProfileView'
import Cart from '../components/Cart/Cart'
import Login from  '../components/signup/Login'
import verifyOtp from '../components/signup/verifyOtp'
import Thanku from '../components/Cart/Thanku'
import Address from '../components/Cart/Address'
import About from '../components/About'
import DeveloperContact from '../components/DeveloperContact'
import Logout from '../components/Logout'
import StoreSelection from '../components/signup/StoreSelection'
Vue.use(VueRouter)

const routes = [
  {
    path: '/home',
    name:'Home',
    component: Home
  },
  {
    path: '/storeSelect',
    name:'storeSelect',
    component: StoreSelection
  },
  // {
  //   path: '/buttons',
  //   name:'Buttons',
  //   component: TopButtons
  // },
  {
    path:'/about',
    name:'About',
    component : About
  },
  {
    path: '/cart',
    name:'Cart',
    component: Cart
  },
  {
    path: '/address',
    name:'Address',
    component: Address
  },
  {
    path: '/wishlist',
    name:'Wishlist',
    component:Wishlist
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    //component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/orders',
    name:'Orders',
    component: Orders
  },
  {
    path: '/orderDetails',
    name:'OrderDetails',
    component: OrderDetails,

  },
  {
    path: '/payments',
    name:'Payments',
    component: Payments
  },
  {
    path: '/profile',
    name:'Profile',
    component: Profile
  },
  {
    path: '/',
    name:'Login',
    component: Login
  },
  {
    path: '/otp',
    name:'OTP',
    component: verifyOtp
  },
  {
    path: '/thankyou/:id',
    component: Thanku,
  },
  {
    path:'/developer',
    component : DeveloperContact,
  },
  {
    path:'/logout',
    component : Logout,
  },


]

const router = new VueRouter({
  // mode: 'history',
  base: '/vue_kriyana/',
  routes
})

export default router
